module.exports = __webpack_public_path__ + "static/media/kill_covid.0ecf29cf.svg";